import { ComponentRef } from "@angular/core";
import { FormFieldComponent } from "./form-field-component";
import { FormContext } from "../form/form-context";

export abstract class DynamicController {
  protected _componentRef: ComponentRef<FormFieldComponent>;

  public set componentRef(_componentRef: ComponentRef<FormFieldComponent>) {
    this._componentRef = _componentRef;
  }

  public abstract onInit(context: FormContext<any>): void;

  protected abstract destory(): void;
}
